import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import BilanDynRecDepGestion from '../Graph/Bilan/BilanDynRecDepGestion';
import BilanDynRecGestion from '../Graph/Bilan/BilanDynRecGestion';
import BilanDynDepGestion from '../Graph/Bilan/BilanDynDepGestion';
import { rescueHtml } from '../components/Tools.js';

const Page6Graph = (props) => {
    const blue = '#069BD3';

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>

            {/* Header */}
            <div style={{display: 'flex'}}>
                <div style={{margin: 25}}>
                    <img style={{width: 200}} src={Logo} />
                </div>

                <div style={{flex: 1}}></div>
                
                <div style={{margin: 25}}>
                    <p style={{color: blue, fontSize: 24}}>{rescueHtml(props.user.nom_organisme)}</p>
                </div>
            </div>

            <div style={{borderBottom: '1px solid '+blue, marginLeft: 25, display: 'flex', alignItems: 'center'}}>
                <p style={{color: blue, fontSize: 26}}>{props.titre}</p>
                <p style={{color: blue, fontSize: 18, marginLeft: 10, fontStyle: 'italic'}}>(en base 100 la première année)</p>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%'}}>
                <div style={{flex: 1, display: 'flex', marginLeft: 25, marginRight: 25}}>
                    <div style={{flex: 1, margin: 5, marginTop: 100}} className='shadow-md rounded'>
                        <BilanDynRecDepGestion user={props.user} annees={props.annees} height={350}/>
                    </div>
                    <div style={{flex: 1, margin: 5, marginTop: 100}} className='shadow-md rounded'>
                        <BilanDynRecGestion user={props.user} annees={props.annees} height={350}/>
                    </div>
                    <div style={{flex: 1, margin: 5, marginTop: 100}} className='shadow-md rounded'>
                        <BilanDynDepGestion user={props.user} annees={props.annees} height={350}/>
                    </div>
                </div>
            </div>


            {/* Footer */}
            <div style={{display: 'flex', marginBottom: 15}}>
                <div style={{marginLeft: 25}}>
                    <p style={{fontSize: 10}}>{props.date}</p>
                </div>
                <div style={{flex: 1}}></div>
                <div style={{marginRight: 25}}>
                    <p style={{fontSize: 10}}>Page : {props.index}</p>
                </div>
            </div>
        </div>
    );
};

export default Page6Graph;
